import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  SingIn2FaConfigurationService,
  // eslint-disable-next-line camelcase
  type Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
} from '../../services/wealthlane-identity-services';

const usePostEnableSingIn2Fa = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onSuccess?: (
    // eslint-disable-next-line camelcase
    response: Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined
  ) => void
): UseMutationResult<
  // eslint-disable-next-line camelcase
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  void,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async () => {
      return await handleRequest(
        SingIn2FaConfigurationService.postApiIdentityApiSingIn2FaConfigurationEnable()
      );
    },
    {
      onSuccess: async (response) => {
        if (response != null) {
          toast.success(
            <ToastComponent label='Success' message='Sign-in 2FA enabled successfully.' />
          );
          await queryClient.invalidateQueries('getIsSingIn2FaEnabled');
          onSuccess && onSuccess(response);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostEnableSingIn2Fa;
